<template>
    <div>
        <div class="header mt-5 mb-5">
            Device
        </div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="'Search Device'"
                        solo
                        height="40px"
                        @keyup.enter="searchDevice()">
                    </v-text-field>
                </div>
                <div class="ml-3">
                    <v-btn
                        height="40px"
                        color="primary"
                        outlined
                        @click="searchDevice()">
                        Search
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    height="40px"
                    @click="createNewDevice()"
                    color="primary"> + Create Device </v-btn>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalDevice"
                :items="devices"
                :loading="loading">
                <template v-slot:[`item.status`]="{ item }">
                    <div>{{ getDeviceStatusText(item.status) }}</div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <v-icon
                            class="mr-2"
                            @click="goToEditDevice(item.id)">
                            edit
                        </v-icon>
                        <v-icon
                            class="mr-2"
                            @click="openDeleteDeviceModal(item)">
                            delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <delete-modal
            ref="modalDelete"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>

        <device-form-modal
            ref="deviceFormModal"
            :mode="mode"
            :updateDeviceId="deviceId"
            @close-modal="closeModal"
            @success-created="getDevices()"
            @success-updated="getDevices()"
        />
    </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal.vue'
import DeviceFormModal from '@/components/Device/DeviceFormModal.vue'

export default {
    name: 'Devices',

    components: {
        DeleteModal,
        DeviceFormModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalDevice: 0,
            deleteForm: {
                header: 'Delete Device',
                content: '',
                path: ''
            },
            devices: [],
            mode: '',
            deviceId: 0
        }
    },

    computed: {
        headers () {
            return [
                { text: 'Device Name', value: 'name', width: '25%' },
                { text: 'Serial Number', value: 'serial_number', width: '30%' },
                { text: 'End Point', value: 'endpoint', width: '25%' },
                { text: 'Status', value: 'status', width: '10%' },
                { text: '', value: 'action', width: '10%', sortable: false }
            ]
        }
    },

    methods: {
        async searchDevice () {
            this.options.page = 1
            await this.getDevices()
        },

        async getDevices () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `devices?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.devices = res.data.data
                this.totalDevice = res.data.total
            }
            this.loading = false
        },

        getDeviceStatusText (status) {
            switch (status) {
                case 'ENBL':
                    return 'Enable'
                case 'DSBL':
                    return 'Disable'
                default:
                    return '-'
            }
        },

        createNewDevice () {
            this.$refs.deviceFormModal.dialog = true
            this.mode = 'create'
        },

        goToEditDevice (id) {
            this.deviceId = id
            this.mode = 'update'
            this.$refs.deviceFormModal.dialog = true
        },

        closeModal () {
            this.mode = ''
        },

        openDeleteDeviceModal (item) {
            this.deleteForm.content = `Are you sure you want to delete "${item.name}" device ?`
            this.deleteForm.path = `device/delete/${item.id}`
            this.$refs.modalDelete.dialog = true
        },

        async deleteSuccess () {
            await this.getDevices()
            this.$notify({
                title: 'Congratulation',
                text: 'Device is deleted.',
                type: 'notify-success'
            })
        }
    },

    watch: {
        options: {
            async handler () {
                await this.getDevices()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
    }
</style>
